var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topTis",class:_vm.nowClass},[(_vm.color == '')?_c('i',{staticClass:"el-icon-warning",staticStyle:{"color":"#7B61FF","font-size":"14px"}}):_vm._e(),_c('div',{staticClass:"desc"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }